import React, { FC } from "react";
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";

import "react-calendar/dist/Calendar.css";
import "react-datetime-picker/dist/DateTimePicker.css";
import "./main.scss";

import { PageAuthLogin } from "./pages/auth";
import Profile from "./pages/profile";
import Firmwares from "./pages/firmwares";
import FirmwaresModifi from "./pages/firmwares/CreateAndEdit";
import { IPageProps, withPageWraper } from "./pages/wraper";
import { UserList } from "./pages/user";
import SongCategoryList from "./pages/category/SongCategoryList";
import SongList from "./pages/songs/SongList";
import SingersList from "./pages/singers";
import ApkList from "./pages/apk";
import CreateAndEditApk from "./pages/apk/CreateAndEditApk";

export const Routes = {
  userList: {
    path: "/users",
    component: UserList,
  },
  profile: {
    path: "/profile",
    component: Profile,
  },
  songCategory: {
    path: "/category",
    component: SongCategoryList,
  },
  firmwares: {
    path: "/firmwares",
    component: Firmwares,
  },
  firmwareEdit: {
    path: "/firmwares/:id",
    component: FirmwaresModifi,
    renderPath: (id: string) => `/firmwares/${id}`,
  },
  firmwareCreate: {
    path: "/firmwares",
    component: FirmwaresModifi,
  },
  songs: {
    path: "/songs",
    component: SongList,
  },
  singers: {
    path: "/singers",
    component: SingersList,
  },
  apk: {
    path: "/apk-file",
    component: ApkList,
  },
  apkCreate: {
    path: "/apk-file/create",
    component: CreateAndEditApk,
  },
  apkModify: {
    path: "/apk-file/:id/edit",
    component: CreateAndEditApk,
    renderPath: (id: string | number) => `/apk-file/${id}/edit`,
  },
};

export const AppRoutes: FC = () => {
  return (
    <Router>
      <Switch>
        {Object.values(Routes).map((item: any, key) => {
          return (
            <Route
              key={key}
              exact
              path={item.path}
              component={withPageWraper((props: IPageProps) => {
                return <item.component {...props} />;
              })}
            />
          );
        })}

        <Route path="/auth/login" component={PageAuthLogin} />
      </Switch>
      <Route exact path="/">
        <Redirect to={Routes?.profile?.path} />
      </Route>
      {/* <Route path='*' component={() => <Redirect to='/profile' />} /> */}
    </Router>
  );
};
